import React from 'react';

import type { CompanyDetails } from '@models/next/Company';
import type { PriceSimulatorForm } from '@models/next/PriceSimulator';
import type { RoutePlanSimulatorStatus, RoutePlanSimulator } from '@models/next/RoutePlanSimulator';
import type { User } from '@models/User';
import type { ReactForm } from '@monoid-dev/mobx-zod-form-react';

export type PriceSimulatorStep = 'input' | 'result';

export interface PriceSimulatorContextValue {
  step: PriceSimulatorStep;
  setStep: (s: PriceSimulatorStep) => void;
  formOutput?: PriceSimulatorForm;
  setFormOutput: (v: PriceSimulatorForm) => void;
  user: User;
  company: CompanyDetails;
  routePlanSimulatorStatus: RoutePlanSimulatorStatus;
  routePlanSimulators?: RoutePlanSimulator[];
  setRoutePlanSimulators: (v: RoutePlanSimulator[]) => void;
}

export const PriceSimulatorContext = React.createContext(
  undefined as any as PriceSimulatorContextValue,
);

export interface PriceSimulatorFormContextValue {
  form: ReactForm<typeof PriceSimulatorForm>;
}

export const PriceSimulatorFormContext = React.createContext(
  undefined as any as PriceSimulatorFormContextValue,
);
